import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  notificationFail,
  notificationSuccess,
} from "../slices/notificationSlice";
import {
  subStanceList,
  setLoader,
  aggSubstanceList,
  relatedSubstanceList,
  getDetailMeasurementsList,
  getSubstanceDetailList,
  getQueryDetailsList,
  substanceThresholdsList,
  getSubstanceHistoryList,
  setLoaderMeasurement,
  substanceThresholdsDefaultList,
  setMeasurementDataNotFound,
  setSubstanceScheduleReportList,
} from "../slices/substanceSlice";
import { API, graphqlOperation } from "aws-amplify";
import {
  GetSubStanceList,
  GetAggMeasurements,
  GetRelatedSubstances,
  getDetailMeasurements,
  getSubstanceDetail,
  GetQueryDetails,
  getSubstanceThresholds,
} from "../../graphql/queries";
import {
  getSubstanceHistoryMutation
} from "../../graphql/mutations";

import { ChangeServiceRequest } from "./commonThunk";
import {
  qaApi,
  devApi,
  devApiMeasurementService,
  qaApidevApiMeasurementService,
  prodApiMeasurementService,
  prodApi,
} from "../../aws-export";
import { RootState } from "../store"
import { convertTemperatureToCelsius } from "../../config/util"
import GrafanaClient from "../../config/grafanaClient";
import DashboardDummyData from './dashboard_dummydata.json'

export const getSubStanceList = createAsyncThunk(
  "substancelist",
  async (_request: any, { dispatch }) => {
    const loginwithtype = localStorage.getItem("loginwith") || "";
    try {
      dispatch(setLoader(true));
      dispatch(
        ChangeServiceRequest({
          request:
            loginwithtype === "qa"
              ? qaApidevApiMeasurementService
              : loginwithtype === "prod"
                ? prodApiMeasurementService
                : devApiMeasurementService,
        })
      );
      const SubStancelist = (await API.graphql(
        graphqlOperation(GetSubStanceList)
      )) as {
        data: any;
        errors: any[];
      };
      if (SubStancelist?.data?.getSettings) {
        dispatch(subStanceList(SubStancelist.data.getSettings));
      }
      dispatch(
        ChangeServiceRequest({
          request:
            loginwithtype === "qa"
              ? qaApi
              : loginwithtype === "prod"
                ? prodApi
                : devApi,
        })
      );
      dispatch(setLoader(false));
    } catch {
      dispatch(
        ChangeServiceRequest({
          request:
            loginwithtype === "qa"
              ? qaApi
              : loginwithtype === "prod"
                ? prodApi
                : devApi,
        })
      );
      dispatch(notificationFail("Something went wrong"));
      dispatch(setLoader(false));
    }
  }
);

// getAggMeasurements thunk
export const getAggMeasurements = createAsyncThunk(
  "getAggMeasurements",
  async (_request: any, { dispatch }) => {
    const loginwithtype = localStorage.getItem("loginwith") || "";
    const serviceRequest =
      loginwithtype === "qa"
        ? qaApidevApiMeasurementService
        : loginwithtype === "prod"
          ? prodApiMeasurementService
          : devApiMeasurementService;

    try {
          const {tenantCode, ...request} = _request
          console.log("tenantCodetenantCode",tenantCode);
          console.log("requestrequestrequest",request);
          
          if(_request.tenantCode !== process.env.REACT_APP_TENANT_CODE){
              dispatch(ChangeServiceRequest({ request: serviceRequest }));
              dispatch(setMeasurementDataNotFound(false));
              dispatch(setLoaderMeasurement(true));

              // const AggMeasurementsList = (await API.graphql(
              //   graphqlOperation(GetAggMeasurements, { params: _request })
              // )) as { data: any; errors: any[] };

              const {tenantCode, ...request} = _request
              const AggMeasurementsList: any = await GrafanaClient().post(
                "/detection/get-aggrmeasurement-data",
                {
                  ...request
                }
              );
              const measurements: any = AggMeasurementsList?.data?.getAggMeasurements || [];
              if (measurements.length > 0) {
                dispatch(aggSubstanceList(measurements));
              } else {
                dispatch(aggSubstanceList([]));
                dispatch(setMeasurementDataNotFound(true));
              }
              return measurements;
          }else{
            const measurements: any = DashboardDummyData.getAggMeasurements || [];
              if (measurements.length > 0) {
                dispatch(aggSubstanceList(measurements));
              } else {
                dispatch(aggSubstanceList([]));
                dispatch(setMeasurementDataNotFound(true));
              }
              return measurements;
          }

    } catch (error) {
      dispatch(aggSubstanceList([]));
      dispatch(notificationFail("Data Not Available in this Location"));
      throw error;
    } finally {
      const resetServiceRequest =
        loginwithtype === "qa" ? qaApi :
          loginwithtype === "prod" ? prodApi : devApi;
      dispatch(ChangeServiceRequest({ request: resetServiceRequest }));
      dispatch(setLoaderMeasurement(false));
    }
  }
);


export const getSubstanceThresholdsThunk = createAsyncThunk(
  "getSubstanceThresholds",
  async (_request: any, { dispatch }) => {
    const loginwithtype = localStorage.getItem("loginwith") || "";
    try {
      dispatch(
        ChangeServiceRequest({
          request:
            loginwithtype === "qa"
              ? qaApidevApiMeasurementService
              : loginwithtype === "prod"
                ? prodApiMeasurementService
                : devApiMeasurementService,
        })
      );
      const ThresholdsList = (await API.graphql(
        graphqlOperation(getSubstanceThresholds, { params: _request })
      )) as { data: any; errors: any[] };
      if (ThresholdsList.data.getSubstanceThresholds) {
        dispatch(
          substanceThresholdsList(
            ThresholdsList.data.getSubstanceThresholds.thresholds
          )
        );
      }
      dispatch(
        ChangeServiceRequest({
          request:
            loginwithtype === "qa"
              ? qaApi
              : loginwithtype === "prod"
                ? prodApi
                : devApi,
        })
      );
      return ThresholdsList?.data?.getSubstanceThresholds?.thresholds;
    } catch {
      dispatch(
        ChangeServiceRequest({
          request:
            loginwithtype === "qa"
              ? qaApi
              : loginwithtype === "prod"
                ? prodApi
                : devApi,
        })
      );
      dispatch(notificationFail("Something went wrong"));
    }
  }
);

export const getSubstanceDefaultThresholdsThunk = createAsyncThunk(
  "getSubstanceDefaultThresholds",
  async (_request: any, { dispatch }) => {
    const loginwithtype = localStorage.getItem("loginwith") || "";
    try {
      dispatch(ChangeServiceRequest({
        request:
          loginwithtype === "qa"
            ? qaApidevApiMeasurementService
            : loginwithtype === "prod"
              ? prodApiMeasurementService
              : devApiMeasurementService,
      })
      );
      const ThresholdsDefaultList = (await API.graphql(
        graphqlOperation(getSubstanceThresholds, { params: _request })
      )) as { data: any; errors: any[] };
      if (ThresholdsDefaultList.data.getSubstanceThresholds.thresholds) {
        dispatch(substanceThresholdsDefaultList(ThresholdsDefaultList.data.getSubstanceThresholds.thresholds))
      }
      dispatch(ChangeServiceRequest({
        request:
          loginwithtype === "qa"
            ? qaApi
            : loginwithtype === "prod"
              ? prodApi
              : devApi,
      })
      );
    } catch {
      dispatch(ChangeServiceRequest({
        request:
          loginwithtype === "qa"
            ? qaApi
            : loginwithtype === "prod"
              ? prodApi
              : devApi,
      })
      );
    }
  }
);

export const GetDetailMeasurements = createAsyncThunk(
  "GetDetailMeasurements",
  async (_request: any, { dispatch, getState }) => {
    const userData = (getState() as RootState)?.authReducer?.userData;
    const loginwithtype = localStorage.getItem("loginwith") || "";
    const items = JSON.parse(localStorage.getItem("tenantId") || "{}");
      const tenantCode = items && items?.tenantId ? items?.tenantCode : userData?.tenantCode;
    try {
      dispatch(setLoaderMeasurement(true));

      if(tenantCode !== process.env.REACT_APP_TENANT_CODE){
              dispatch(
                ChangeServiceRequest({
                  request:
                    loginwithtype === "qa"
                      ? qaApidevApiMeasurementService
                      : loginwithtype === "prod"
                        ? prodApiMeasurementService
                        : devApiMeasurementService,
                })
              );

              // const DetailMeasurementsList = (await API.graphql(
              //   graphqlOperation(getDetailMeasurements, { params: _request })
              // )) as { data: any; errors: any[] };

              const DetailMeasurementsList: any = await GrafanaClient().post(
                "/detection/get-getDetailMeasurements-data",
                {
                  ..._request
                }
              );

              if (DetailMeasurementsList?.data?.getDetailMeasurements) {
                dispatch(
                  getDetailMeasurementsList(
                    DetailMeasurementsList?.data?.getDetailMeasurements
                  )
                );
              }
              dispatch(
                ChangeServiceRequest({
                  request:
                    loginwithtype === "qa"
                      ? qaApi
                      : loginwithtype === "prod"
                        ? prodApi
                        : devApi,
                })
              );
              dispatch(setLoaderMeasurement(false));
              return DetailMeasurementsList?.data?.getDetailMeasurements || []
      }else{
        const data =  DashboardDummyData.getDetailMeasurements;
        dispatch(getDetailMeasurementsList(data));
          dispatch(setLoaderMeasurement(false));
          return data || []
      }
    } catch (error) {
      dispatch(
        ChangeServiceRequest({
          request:
            loginwithtype === "qa"
              ? qaApi
              : loginwithtype === "prod"
                ? prodApi
                : devApi,
        })
      );
      dispatch(getDetailMeasurementsList([]));
      dispatch(notificationFail("Data Not Available in this Location"));
      dispatch(setLoaderMeasurement(false));
      return error;
    }
  }
);

export const GetSubstanceDetail = createAsyncThunk(
  "GetSubstanceDetail",
  async (_request: any, { dispatch, getState }) => {
    const loginwithtype = localStorage.getItem("loginwith") || "";
    const userData = (getState() as RootState)?.authReducer?.userData;    
    const items = JSON.parse(localStorage.getItem("tenantId") || "{}");
    const tenantCode = items && items?.tenantId ? items?.tenantCode : userData?.tenantCode;
    console.log('GetSubstanceDetailGetSubstanceDetail');    
    try {
      dispatch(getSubstanceDetailList({}));
      dispatch(setLoader(true));
        if(tenantCode !== process.env.REACT_APP_TENANT_CODE){                                
              dispatch(
                ChangeServiceRequest({
                  request:
                    loginwithtype === "qa"
                      ? qaApidevApiMeasurementService
                      : loginwithtype === "prod"
                        ? prodApiMeasurementService
                        : devApiMeasurementService,
                })
              );
              const SubstanceDetails = (await API.graphql(
                graphqlOperation(getSubstanceDetail, { params: _request })
              )) as { data: any; errors: any[] };

              if (SubstanceDetails?.data?.getSubstanceDetails) {
                let data = SubstanceDetails?.data?.getSubstanceDetails
                if (userData?.temperature_unit === 'C' && _request?.substanceKey === 'temperature') {
                  const convertedData = SubstanceDetails?.data?.getSubstanceDetails?.measures?.map((value: any) => {
                    const celsiusValue = convertTemperatureToCelsius(value?.value)?.onlyNumber;
                    return {
                      ...value,
                      value: celsiusValue
                    }
                  })
                  data = { ...data, measures: convertedData }
                }
                dispatch(
                  getSubstanceDetailList(data)
                );
              }
              dispatch(
                ChangeServiceRequest({
                  request:
                    loginwithtype === "qa"
                      ? qaApi
                      : loginwithtype === "prod"
                        ? prodApi
                        : devApi,
                })
              );
              dispatch(setLoader(false));
              return SubstanceDetails;
        }else{
            // dispatch(getSubstanceDetailList([]));
            const data = DashboardDummyData.getSubstanceDetailsMain.getSubstanceDetails;
            dispatch(getSubstanceDetailList(data));
            dispatch(setLoader(false));
            return {data:DashboardDummyData.getSubstanceDetailsMain};
        }
    } catch {
      dispatch(
        ChangeServiceRequest({
          request:
            loginwithtype === "qa"
              ? qaApi
              : loginwithtype === "prod"
                ? prodApi
                : devApi,
        })
      );
      dispatch(notificationFail("Something went wrong"));
      dispatch(setLoader(false));
    }
  }
);

export const GetSubstanceDetailDetection = createAsyncThunk(
  "GetSubstanceDetail",
  async (_request: any, { dispatch, getState }) => {
    const loginwithtype = localStorage.getItem("loginwith") || "";
    const userData = (getState() as RootState)?.authReducer?.userData;

    try {
      dispatch(setLoader(true));
      dispatch(
        ChangeServiceRequest({
          request:
            loginwithtype === "qa"
              ? qaApidevApiMeasurementService
              : loginwithtype === "prod"
                ? prodApiMeasurementService
                : devApiMeasurementService,
        })
      );
      if (_request.location !== "" && _request.location !== undefined && _request.substanceKey !== "" && _request.substanceKey !== undefined) {
        const { facilityKey, ...reqparsms } = _request;
        console.log("reqparsmsreqparsms", reqparsms);
        const SubstanceDetails = (await API.graphql(
          graphqlOperation(getSubstanceDetail, { params: reqparsms })
        )) as { data: any; errors: any[] };

        if (SubstanceDetails?.data?.getSubstanceDetails) {
          let data = SubstanceDetails?.data?.getSubstanceDetails
          if (userData?.temperature_unit === 'C' && _request?.substanceKey === 'temperature') {
            const convertedData = SubstanceDetails?.data?.getSubstanceDetails?.measures?.map((value: any) => {
              const celsiusValue = convertTemperatureToCelsius(value?.value)?.onlyNumber;
              return {
                ...value,
                value: celsiusValue
              }
            })
            data = { ...data, measures: convertedData }
          }
          dispatch(
            getSubstanceDetailList(data)
          );
        }
        dispatch(
          ChangeServiceRequest({
            request:
              loginwithtype === "qa"
                ? qaApi
                : loginwithtype === "prod"
                  ? prodApi
                  : devApi,
          })
        );
        dispatch(setLoader(false));
        return SubstanceDetails;
      } else if ((_request.location === "" || _request.location === undefined) && _request.substanceKey !== "" && _request.substanceKey !== undefined) { // call api grafana ec2 
        dispatch(setLoader(true));
        const requestParams = {
          substances: _request.substanceKey,
          fromDate: _request.fromDate,
          toDate: _request.toDate,
          facilityKey: _request.facilityKey,
          location: "",
          interval: _request.interval
        }
        const result: any = await GrafanaClient().post(
          "/substance-detection/get-substance-detection-data",
          {
            ...requestParams
          }
        );
        if (result?.data?.data?.getSubstanceDetails.measures) {
          dispatch(
            getSubstanceDetailList(
              result?.data?.data?.getSubstanceDetails
            )
          );
        }
        dispatch(setLoader(false));
        return result?.data?.data?.getSubstanceDetails;
      }

    } catch {
      dispatch(
        ChangeServiceRequest({
          request:
            loginwithtype === "qa"
              ? qaApi
              : loginwithtype === "prod"
                ? prodApi
                : devApi,
        })
      );
      dispatch(notificationFail("Something went wrong"));
      dispatch(setLoader(false));
    }
  }
);

export const getQueryDetailThunk = createAsyncThunk(
  "getQueryDetailThunk",
  async (_request: any, { dispatch }) => {
    const loginwithtype = localStorage.getItem("loginwith") || "";
    try {
      dispatch(setLoader(true));
      dispatch(
        ChangeServiceRequest({
          request:
            loginwithtype === "qa"
              ? qaApidevApiMeasurementService
              : loginwithtype === "prod"
                ? prodApiMeasurementService
                : devApiMeasurementService,
        })
      );

      const QueryDetailList = (await API.graphql(
        graphqlOperation(GetQueryDetails, { params: _request })
      )) as { data: any; errors: any[] };
      if (QueryDetailList.data.getQueryDetails.records) {
        dispatch(getQueryDetailsList(QueryDetailList.data.getQueryDetails));
      } else {
        dispatch(getQueryDetailsList(QueryDetailList.data.getQueryDetails));
        dispatch(notificationFail("Data Not Found"));
      }
      dispatch(
        ChangeServiceRequest({
          request:
            loginwithtype === "qa"
              ? qaApi
              : loginwithtype === "prod"
                ? prodApi
                : devApi,
        })
      );
      dispatch(setLoader(false));
    } catch {
      dispatch(
        ChangeServiceRequest({
          request:
            loginwithtype === "qa"
              ? qaApi
              : loginwithtype === "prod"
                ? prodApi
                : devApi,
        })
      );
      dispatch(notificationFail("Something went wrong"));
      dispatch(setLoader(false));
    }
  }
);

export const getSubstanceHistory = createAsyncThunk(
  "getSubstanceHistory",
  async (_request: any, { dispatch, getState }) => {
    try {
      const userData = (getState() as RootState)?.authReducer?.userData;
      const response = await API.graphql({
        ...graphqlOperation(getSubstanceHistoryMutation, _request.request),
        authMode: "AMAZON_COGNITO_USER_POOLS",
      }) as { data: any, errors: any[] };

      let data = response?.data?.getSubstanceNotificationHistory?.data;
      if (response?.data?.getSubstanceNotificationHistory?.data?.length > 0 && userData?.temperature_unit === 'C' && _request?.request?.substance.includes('temperature')) {
        data = response?.data?.getSubstanceNotificationHistory?.data?.map((value: any) => {
          if (value?.name === 'temperature') {
            return {
              ...value,
              items: value?.items?.map((item: any) => {
                return {
                  ...item,
                  value: convertTemperatureToCelsius(item?.value || 0)?.onlyNumber
                }
              })
            }
          }
          return value;
        })
      }
      dispatch(getSubstanceHistoryList(data))
    } catch (e) {
      dispatch(notificationFail("Something Went Wrong"))
    }
  }
);

export const getSubstanceHistoryWithElevatedKey = createAsyncThunk(
  "getSubstanceHistoryElevated",
  async (_request: any, { dispatch }) => {
    try {

      const data = await API.graphql({
        ...graphqlOperation(getSubstanceHistoryMutation, _request.request),
        authMode: "AMAZON_COGNITO_USER_POOLS",
      }) as { data: any, errors: any[] };

      const index = _request.substanceHistory.map((item: any) => item.name).indexOf(_request.request.substance[0]);
      const substanceHistoryList: any = [..._request.substanceHistory];

      if (data?.data?.getSubstanceNotificationHistory?.data) {
        substanceHistoryList[index] = {
          ...substanceHistoryList[index],
          items: data?.data?.getSubstanceNotificationHistory?.data[0].items,
          LastEvaluatedPk: data?.data?.getSubstanceNotificationHistory?.data[0].LastEvaluatedPk,
          LastEvaluatedSk: data?.data?.getSubstanceNotificationHistory?.data[0].LastEvaluatedSk,
          totalPage: data?.data?.getSubstanceNotificationHistory?.data[0].totalPage,
        }

        dispatch(getSubstanceHistoryList(substanceHistoryList))

        if (_request?.setOnPageLoader) {
          _request?.setOnPageLoader(false);
        };
        if (_request?.setPrevButtonClicked) {
          _request?.setPrevButtonClicked(false);
        }
        if (_request?.setNextButtonClicked) {
          _request?.setNextButtonClicked(false);
        }

      }
    } catch (error) {
      console.log('error', error);
      if (_request?.setOnPageLoader) {
        _request?.setOnPageLoader(false);
      };

      dispatch(notificationFail("Something Went Wrong"))
    }
  }
);


export const GetRelatedSubstancesThunk = createAsyncThunk(
  "GetRelatedSubstancesThunk",
  async (_request: any, { dispatch, getState }) => {
    const loginwithtype = localStorage.getItem("loginwith") || "";
    const userData = (getState() as RootState)?.authReducer?.userData;    
    const items = JSON.parse(localStorage.getItem("tenantId") || "{}");
    const tenantCode = items && items?.tenantId ? items?.tenantCode : userData?.tenantCode;
    try {
        if(tenantCode !== process.env.REACT_APP_TENANT_CODE){ 
              dispatch(
                ChangeServiceRequest({
                  request:
                    loginwithtype === "qa"
                      ? qaApidevApiMeasurementService
                      : loginwithtype === "prod"
                        ? prodApiMeasurementService
                        : devApiMeasurementService,
                })
              );

              const RelatedSubstanceList = (await API.graphql(
                graphqlOperation(GetRelatedSubstances, { params: _request })
              )) as { data: any; errors: any[] };
              if (RelatedSubstanceList?.data?.getRelatedSubstances?.substances) {
                dispatch(
                  relatedSubstanceList(RelatedSubstanceList?.data?.getRelatedSubstances?.substances)
                );
              }
              dispatch(
                ChangeServiceRequest({
                  request:
                    loginwithtype === "qa"
                      ? qaApi
                      : loginwithtype === "prod"
                        ? prodApi
                        : devApi,
                })
              );
              return (RelatedSubstanceList?.data?.getRelatedSubstances?.substances) || [];
        }else{
          const data = DashboardDummyData.getRelatedSubstances.getRelatedSubstances.substances;
          dispatch(relatedSubstanceList(data));
          return (data) || [];
        }
    } catch {
      dispatch(
        ChangeServiceRequest({
          request:
            loginwithtype === "qa"
              ? qaApi
              : loginwithtype === "prod"
                ? prodApi
                : devApi,
        })
      );
      dispatch(relatedSubstanceList([]));
      // dispatch(notificationFail("Data Not Available for this location and substance"));
    }
  }
);


export const getSubstanceHistoryNew = createAsyncThunk(
  "getSubstanceHistoryNew",
  async (_request: any, { dispatch, getState }) => {
    try {
      const userData = (getState() as RootState)?.authReducer?.userData;
      const response = await GrafanaClient().post(
        "/substance-history/get-substance-history-data",
        _request
      );

      let data = response?.data?.getSubstanceNotificationHistory?.data;
      if (
        response?.data?.getSubstanceNotificationHistory?.data?.length > 0 &&
        userData?.temperature_unit === "C" &&
        _request?.request?.substance.includes("temperature")
      ) {
        data = response?.data?.getSubstanceNotificationHistory?.data?.map(
          (value: any) => {
            if (value?.name === "temperature") {
              return {
                ...value,
                items: value?.items?.map((item: any) => {
                  return {
                    ...item,
                    value: convertTemperatureToCelsius(item?.value || 0)
                      ?.onlyNumber,
                  };
                }),
              };
            }
            return value;
          }
        );
      }
      dispatch(getSubstanceHistoryList(data));
      if (data?.length === 0) {
        dispatch(notificationSuccess("Data is not available."));
      }
    } catch (e) {
      dispatch(notificationFail("Something Went Wrong"));
    }
  }
);

export const getSubstanceHistoryNewPagination = createAsyncThunk(
  "getSubstanceHistoryNewPagination",
  async (_request: any, { dispatch, getState }) => {
    try {
      const userData = (getState() as RootState)?.authReducer?.userData;
      const response = await GrafanaClient().post(
        "/substance-history/get-substance-history-data",
        {
          interval: _request?.interval,
          location: _request?.location,
          page: _request?.page,
          substances: _request?.substances,
        }
      );

      const index = _request.substanceHistory.map((item: any) => item.name).indexOf(_request.substances[0]);
      const substanceHistoryList: any = [..._request.substanceHistory];

      let data = substanceHistoryList;

      if (
        response?.data?.getSubstanceNotificationHistory?.data?.length > 0 &&
        userData?.temperature_unit === "C" &&
        _request?.request?.substance.includes("temperature")
      ) {
        data = response?.data?.getSubstanceNotificationHistory?.data?.map(
          (value: any) => {
            if (value?.name === "temperature") {
              return {
                ...value,
                items: value?.items?.map((item: any) => {
                  return {
                    ...item,
                    value: convertTemperatureToCelsius(item?.value || 0)
                      ?.onlyNumber,
                  };
                }),
              };
            }
            return value;
          }
        );
      }

      if (data) {
        substanceHistoryList[index] = {
          ...substanceHistoryList[index],
          items: response?.data?.getSubstanceNotificationHistory?.data[0].items,
          totalPage:
            response?.data?.getSubstanceNotificationHistory?.data[0].totalPage,
        };

        if (_request?.setOnPageLoader) {
          _request?.setOnPageLoader(false);
        }
        if (_request?.setPrevButtonClicked) {
          _request?.setPrevButtonClicked(false);
        }
        if (_request?.setNextButtonClicked) {
          _request?.setNextButtonClicked(false);
        }
      }

      dispatch(getSubstanceHistoryList(substanceHistoryList));
    } catch (e) {
      dispatch(notificationFail("Something Went Wrong"));
    }
  }
);

export const saveSubstanceHistoryConfiguration = createAsyncThunk(
  "saveSubstanceHistoryConfiguration",
  async (_request: any, { dispatch }) => {
    try {
      dispatch(setLoader(true));
      await GrafanaClient().post(
        "/substance-history/create-substance-history-config",
        {
          userId: _request?.userId,
          substanceKeys: _request?.substances,
          locations: _request?.locations,
          time_cycle: _request?.time_cycle,
          interval: _request?.interval,
          reportName: _request?.reportName,
          tenantId: _request?.tenantId,
          tenantCode: _request?.tenantCode,
          report_type: "substance_history",
        }
      );
      dispatch(notificationSuccess("Report scheduled successfully"));
      if (_request?.handleClose) {
        _request?.handleClose();
      }
      dispatch(setLoader(false));
    } catch (e) {
      dispatch(setLoader(false));
      dispatch(notificationFail("Something Went Wrong"));
    }
  }
);

export const fetchUserConfigurationCount = createAsyncThunk(
  "fetchUserConfigurationCount",
  async (_request: any, { dispatch }) => {
    try {
      const result: any = await GrafanaClient().get(
        "/substance-history/fetch-config-count",
        {
          params: {
            userId: _request?.userId,
          },
        }
      );
      return result;
    } catch (e) {
      dispatch(notificationFail("Something Went Wrong"));
    }
  }
);

export const getSubstanceScheduleReports = createAsyncThunk(
  "getSubstanceScheduleReports",
  async (_request: any, { dispatch }) => {
    try {
      const response = await GrafanaClient().get(
        "/substance-history/fetch-substance-history-config",
        {
          params: {
            userId: _request?.userId,
            tenantCode: _request?.tenantCode,
          },
        }
      );

      dispatch(setSubstanceScheduleReportList(response?.data?.result));
    } catch (e) {
      dispatch(notificationFail("Something Went Wrong"));
    }
  }
);

export const deleteSubstanceScheduleReports = createAsyncThunk(
  "deleteSubstanceScheduleReports",
  async (_request: any, { dispatch }) => {
    try {
      const response = await GrafanaClient().post(
        "/substance-history/delete-substance-history-config",
        _request
      );

      dispatch(notificationSuccess("Schedule Reports Deleted successfully"));
      return response;
    } catch (e) {
      dispatch(notificationFail("Something Went Wrong"));
    }
  }
);

export const modifySubstanceScheduleReportsActivation = createAsyncThunk(
  "modifySubstanceScheduleReportsActivation",
  async (_request: any, { dispatch }) => {
    try {
      await GrafanaClient().post(
        _request?.type === "stop"
          ? "/substance-history/stop-substance-history-config"
          : "/substance-history/restart-substance-history-config",
        {
          pk: _request?.pk,
          sk: _request?.sk,
        }
      );

      dispatch(
        notificationSuccess(
          `Schedule Reports ${_request?.type === "stop" ? "Paused" : "Resumed"
          } successfully`
        )
      );
    } catch (e) {
      dispatch(notificationFail("Something Went Wrong"));
    }
  }
);